import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@unite-us/app-components';
import { formatUpdatedAt } from '../utils/formatUpdatedAt';

export function InteractionCardHeader({
  title,
  updatedAt,
  interactionId,
  onEdit,
  onDelete,
  deleteDisabled,
}) {
  return (
    <div className="flex items-start gap-2 pb-4">
      <Icon
        className="mt-0.5 shrink-0"
        color="text-blue"
        icon="SocialEnrichment"
        size={20}
      />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <h3
            className="m-0 text-base font-bold text-text-blue"
            data-testid="structured-interaction-card-title"
          >
            {title}
          </h3>
          <span
            className="text-sm italic text-dark-grey"
            data-testid="structured-interaction-card-updated-at"
          >
            Last updated {formatUpdatedAt(updatedAt)}
          </span>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2 self-center">
        <button
          type="button"
          aria-label="Edit Interaction"
          className="cursor-pointer"
          data-testid={`structured-interaction-edit-${interactionId}`}
          onClick={onEdit}
        >
          <Icon icon="Pencil" color="action-blue" size={20} />
        </button>
        <button
          type="button"
          aria-label="Delete Interaction"
          className={deleteDisabled ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
          data-testid={`structured-interaction-delete-${interactionId}`}
          disabled={deleteDisabled}
          onClick={onDelete}
        >
          <Icon icon="Delete" color="action-blue" size={20} />
        </button>
      </div>
    </div>
  );
}

InteractionCardHeader.propTypes = {
  title: PropTypes.string,
  updatedAt: PropTypes.string,
  interactionId: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  deleteDisabled: PropTypes.bool,
};

InteractionCardHeader.defaultProps = {
  title: '',
  updatedAt: undefined,
  deleteDisabled: false,
};
